import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button, { ButtonType } from 'components/Button';
import FormNavigation from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import NumberInput from 'components/NumberInput';
import IncomeDisclaimerNote from 'components/Common/IncomeDisclaimerNote/IncomeDisclaimerNote';

import { YourIncomeVariable } from 'enums/LoanFormVariables';
import { setAdditionalIncome as setAdditionalIncomeAction } from 'handlers/yourEmployer';
import { getYourIncome } from 'selectors/yourIncome';
import { getYourEmployer } from 'selectors/yourEmployer';
import { FlowComponentType } from 'routes/types';
import { getParsedNumericValue } from 'utils/getParsedNumericValue';
import { ANNUAL_INCOME_MAX_LENGTH } from 'components/Verification/Steps/EmploymentDetails/employmentDetailsUtils';

import styles from './AdditionalIncome.module.scss';

const AdditionalIncome = ({ handleNext, navigationInfo }: FlowComponentType) => {
  const dispatch = useDispatch();
  const employerName = useSelector(getYourIncome)[YourIncomeVariable.EmployerName];
  const { additionalIncome: savedAdditionalIncome } = useSelector(getYourEmployer);

  const [additionalIncome, setAdditionalIncome] = useState<number | undefined>(savedAdditionalIncome ?? undefined);

  const handleApply = () => {
    dispatch(setAdditionalIncomeAction(additionalIncome));
    handleNext();
  };

  const handleSkip = () => {
    dispatch(setAdditionalIncomeAction(undefined));
    handleNext();
  };

  const subtitle = employerName
    ? `This is in addition to your income at ${employerName}`
    : 'This is in addition to your income';

  return (
    <>
      <FormNavigation {...navigationInfo} />
      <FormContainer title="Any additional income?" subtitle={subtitle}>
        <div className={styles.container}>
          <NumberInput
            label="Additional annual income"
            inputMode="numeric"
            prefix="$"
            placeholder="$"
            thousandSeparator
            name="additionalIncome"
            value={additionalIncome !== undefined ? `${additionalIncome}` : undefined}
            onChange={(event) => setAdditionalIncome(getParsedNumericValue(event.target.value))}
            maxLength={ANNUAL_INCOME_MAX_LENGTH}
            autoFocus
          />
          <IncomeDisclaimerNote />
        </div>
        <div className={styles.container}>
          <Button onClick={handleApply} disabled={additionalIncome === undefined}>
            Apply
          </Button>
          <Button type={ButtonType.Transparent} onClick={handleSkip}>
            Skip
          </Button>
        </div>
      </FormContainer>
    </>
  );
};

export default AdditionalIncome;
